export default __webpack_public_path__ + "static/media/q2_2_step6.f6fb9f6c.png";